if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.currentIndex = 0;
        this.mediaElements = [];

        // Intercept pointerup during capture phase so clicking nav buttons or active media does NOT trigger ModalDialog's pointerup hide
        this.addEventListener(
          'pointerup',
          (event) => {
            if (
              event.target.closest('.product-media-modal__nav') ||
              event.target.closest('img, video, deferred-media, product-model')
            ) {
              event.stopPropagation();
            }
          },
          true
        );

        // Backdrop click to close (when clicking outside media and outside navigation)
        this.addEventListener('click', (event) => {
          if (
            !event.target.closest('.product-media-modal__nav') &&
            !event.target.closest('img, video, deferred-media, product-model')
          ) {
            this.hide();
          }
        });

        // Keydown navigation
        window.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.next();
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.prev();
          }
        });

        // Touch swipe gestures for mobile
        let touchStartX = 0;
        let touchStartY = 0;
        this.addEventListener(
          'touchstart',
          (event) => {
            touchStartX = event.changedTouches[0].screenX;
            touchStartY = event.changedTouches[0].screenY;
          },
          { passive: true }
        );

        this.addEventListener(
          'touchend',
          (event) => {
            const touchEndX = event.changedTouches[0].screenX;
            const touchEndY = event.changedTouches[0].screenY;
            const diffX = touchEndX - touchStartX;
            const diffY = touchEndY - touchStartY;
            if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 35) {
              if (diffX < 0) {
                this.next();
              } else {
                this.prev();
              }
            }
          },
          { passive: true }
        );

        // Bind nav buttons
        this.initNavButtons();
      }

      initNavButtons() {
        const prevBtn = this.querySelector('.product-media-modal__nav-btn--prev');
        const nextBtn = this.querySelector('.product-media-modal__nav-btn--next');
        const closeBtn = this.querySelector('.product-media-modal__nav-btn--close');

        if (prevBtn) {
          prevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.prev();
          });
        }
        if (nextBtn) {
          nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.next();
          });
        }
        if (closeBtn) {
          closeBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.hide();
          });
        }
      }

      getMediaElements() {
        return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
      }

      show(opener) {
        super.show(opener);
        this.mediaElements = this.getMediaElements();
        const targetId = opener ? opener.getAttribute('data-media-id') : null;

        if (targetId) {
          const foundIndex = this.mediaElements.findIndex(
            (el) => el.getAttribute('data-media-id') === targetId
          );
          this.currentIndex = foundIndex !== -1 ? foundIndex : 0;
        } else {
          this.currentIndex = 0;
        }

        this.updateActiveMedia();
        this.updateNavButtons();
      }

      updateActiveMedia() {
        if (!this.mediaElements || this.mediaElements.length === 0) {
          this.mediaElements = this.getMediaElements();
        }
        if (this.mediaElements.length === 0) return;

        this.mediaElements.forEach((element, index) => {
          if (index === this.currentIndex) {
            element.classList.add('active');
            const template = element.querySelector('template');
            if (
              element.nodeName === 'DEFERRED-MEDIA' &&
              template &&
              template.content &&
              template.content.querySelector('.js-youtube')
            ) {
              element.loadContent();
            }
          } else {
            element.classList.remove('active');
          }
        });
      }

      updateNavButtons() {
        const prevBtn = this.querySelector('.product-media-modal__nav-btn--prev');
        const nextBtn = this.querySelector('.product-media-modal__nav-btn--next');
        const total = this.mediaElements.length;

        if (total <= 1) {
          if (prevBtn) prevBtn.style.display = 'none';
          if (nextBtn) nextBtn.style.display = 'none';
        } else {
          if (prevBtn) prevBtn.style.display = 'inline-flex';
          if (nextBtn) nextBtn.style.display = 'inline-flex';
        }
      }

      next() {
        if (!this.mediaElements || this.mediaElements.length <= 1) return;
        this.currentIndex = (this.currentIndex + 1) % this.mediaElements.length;
        this.updateActiveMedia();
      }

      prev() {
        if (!this.mediaElements || this.mediaElements.length <= 1) return;
        this.currentIndex = (this.currentIndex - 1 + this.mediaElements.length) % this.mediaElements.length;
        this.updateActiveMedia();
      }
    }
  );
}

// Ensure clicking anywhere on the product image thumbnail triggers the modal opener button
document.addEventListener('click', (event) => {
  const opener = event.target.closest('modal-opener.product__modal-opener');
  if (opener && !event.target.closest('.product__media-toggle')) {
    const btn = opener.querySelector('.product__media-toggle');
    if (btn) {
      btn.click();
    }
  }
});

